import { lazy } from 'react';

export const SignInPageLazy = lazy(() => import('./sign-in-page'));
